// Достаёт человекочитаемое сообщение об ошибке запуска сервиса.
// Принимает как Axios-ошибку (error.response.data.payload.detail),
// так и тело ответа с success: false ({ payload: { detail } }).
export function getServiceErrorMessage(
  source,
  fallback = "Сервис не запустился"
) {
  const detail =
    source?.response?.data?.payload?.detail ?? source?.payload?.detail;
  return typeof detail === "string" && detail ? detail : fallback;
}
